import { render, staticRenderFns } from "./yunchanxinshen.vue?vue&type=template&id=1c21c298&scoped=true"
import script from "./yunchanxinshen.vue?vue&type=script&lang=js"
export * from "./yunchanxinshen.vue?vue&type=script&lang=js"
import style0 from "./yunchanxinshen.vue?vue&type=style&index=0&id=1c21c298&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21c298",
  null
  
)

export default component.exports